import Index from '@/views/settings/message-templates/index.vue';
import { Roles } from '@common/app.config';

const authMeta = {
  auth: true,
  authorize: [Roles.superAdmin, Roles.admin],
};

export default [
  {
    path: '/message-templates',
    name: 'message-templates',
    component: Index,
    meta: authMeta,
  },
];
